import { useEffect } from 'react';
import clsx from 'clsx';
import { Box, Overlay } from '@alf/uikit';
import { ModalProvider, useSiteSettings } from '@namespace/cms';
import { MODAL_QUERY_PARAMETER_NAME } from '@namespace/helpers';
import { useSearchParams } from '@namespace/router';
import { PageInContainer } from '../../PageInContainer';

import styles from './index.module.css';

const disableScrollHandler = (e) => {
  e.preventDefault();
};

const disableScrollForPage = () => {
  // When the modal is shown, we want a fixed body
  document.body.style.overflowY = 'hidden';
  document.addEventListener('touchmove', disableScrollHandler, {
    passive: false
  });
};

const enableScrollForPage = () => {
  document.body.style.overflowY = 'auto';
  document.removeEventListener('touchmove', disableScrollHandler);
};

/**
 * This component relies on a value in the search parameters
 * that specifies the page to be opened as a modal.
 */
export const PageInModal = ({
  componentsMap,
  FALLBACK_PAGES,
  modalPageWrapperClassName = '',
  modalPageOverlayClassName = '',
  modalPageContentClassName = ''
}) => {
  const searchParams = useSearchParams();
  const siteSettings = useSiteSettings();

  const pagePath = searchParams[MODAL_QUERY_PARAMETER_NAME];
  const { modalPageLayoutOverrides } = siteSettings || {};

  useEffect(() => {
    if (pagePath) {
      disableScrollForPage();
    } else {
      enableScrollForPage();
    }

    return () => {
      enableScrollForPage();
    };
  }, [pagePath]);

  if (!pagePath) {
    return null;
  }

  return (
    <ModalProvider>
      <Box className={clsx(styles.modalWrapper, modalPageWrapperClassName)}>
        <Overlay classNames={{ wrapperClass: modalPageOverlayClassName }} />
        <Box className={clsx(styles.content, modalPageContentClassName)}>
          <PageInContainer
            key={pagePath}
            pagePath={pagePath}
            componentsMap={componentsMap}
            FALLBACK_PAGES={FALLBACK_PAGES}
            layoutType={modalPageLayoutOverrides[pagePath.replace(/\/$/, '')]}
          />
        </Box>
      </Box>
    </ModalProvider>
  );
};
